import React from "react";
import { ParsedOverviewDetailItem } from "../overviewWidget.state";

export const OverviewItemsLayout = {
    Empty: (): JSX.Element => {
      return (
        <div className="page__empty ls-container ls-gutter ls-spacing">
          <p className="text--s">Geen resultaten gevonden.</p>
        </div>
      )
    }
  }

export function renderStandardItems(items: Immutable.List<ParsedOverviewDetailItem>): JSX.Element {
    return <></>;
}
